import type { ApiFieldIssue } from '../types/api';

/** Error de la API ya normalizado. La interfaz nunca inspecciona la respuesta cruda. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: ApiFieldIssue[];

  constructor(status: number, code: string, message: string, details: ApiFieldIssue[] = []) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }

  get isNetworkError(): boolean {
    return this.status === 0;
  }

  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  get isForbidden(): boolean {
    return this.status === 403;
  }

  get isValidation(): boolean {
    return this.code === 'VALIDATION_ERROR';
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
